import { SmsLog, WEFResponse } from '../Types';
import api from '../configs/api.config';

export const getSmsHistory = async (clientId: string): Promise<WEFResponse<SmsLog[]>> => {
  const { data } = await api.get<WEFResponse<SmsLog[]>>(`/Notification/sms-history/${clientId}`);
  return data;
};
